import { Box, Column } from "@hightouch/htui";

import { Navigate, NoContextOutlet } from "src/router";
import { useResourcePermission } from "src/components/permission/use-resource-permission";
import { PageSpinner } from "src/components/loading";
import { ImagePickerBrandFilterContext } from "src/components/llm/content-images/image-picker-brand-filter";

import { CepTermsOfService } from "./components/cep-tos";

const ND_VIEW_PERMISSION = {
  v2: {
    resource: "workspace" as const,
    grant: "can_view_native_delivery" as const,
  },
};

export function CepLayout() {
  const { isPermitted, isLoading } = useResourcePermission(ND_VIEW_PERMISSION);

  if (isLoading) {
    return <PageSpinner />;
  }

  if (!isPermitted) {
    return <Navigate to="/" replace />;
  }

  return (
    // Every Native Delivery route offers brand filters in its image picker.
    <ImagePickerBrandFilterContext.Provider value>
      <Column h="100%" minH={0}>
        <CepTermsOfService />
        <Box flex={1} minH={0}>
          <NoContextOutlet />
        </Box>
      </Column>
    </ImagePickerBrandFilterContext.Provider>
  );
}
